// day-calendar.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { runtimeLogger } from '../../../utils/runtime-logger.util';
import { Router } from '@angular/router'; // Adicionado
import { AppointmentsService } from '../../../services/appointments.service';
import { AgendamentoDia } from '../../../interfaces/appointment.interface';
import { LocalStorageUtil } from '../../../utils/local-storage.util';

@Component({
  selector: 'app-day-calendar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './day-calendar.html',
  styleUrls: ['./day-calendar.scss']
})
export class DayCalendar implements OnInit {
  currentDate: Date = new Date();

  // Formatação da data
  dayName: string = '';
  dayNumber: string = '';
  monthName: string = '';
  year: string = '';

  // Dados da API
  totalAgendamentos: number = 0;
  timeSlots: Array<{hour: string, appointments: AgendamentoDia[]}> = [];

  // Estado
  loading: boolean = false;
  error: boolean = false;

  constructor(
    private appointmentsService: AppointmentsService,
    private router: Router // Adicionado
  ) {}

  ngOnInit(): void {
    this.updateDateInfo();
    this.loadAppointmentsForDay();
  }

  private updateDateInfo(): void {
    this.dayName = this.currentDate.toLocaleDateString('pt-BR', { weekday: 'long' });
    this.dayNumber = this.currentDate.getDate().toString();
    this.monthName = this.currentDate.toLocaleDateString('pt-BR', { month: 'long' });
    this.year = this.currentDate.getFullYear().toString();
  }

  loadAppointmentsForDay(): void {
    this.loading = true;
    this.error = false;

    const dataISO = this.appointmentsService.formatDateToISO(this.currentDate);

    this.appointmentsService.getAppointmentsDia(LocalStorageUtil.getSelectedVWDn(), dataISO).subscribe({
      next: (response) => {
        this.totalAgendamentos = response.totalAgendamentos;
        this.processAppointments(response.agendamentos);
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar agendamentos do dia:', error);
        this.error = true;
        this.loading = false;
      }
    });
  }

  private processAppointments(agendamentos: AgendamentoDia[]): void {
    runtimeLogger.debug('Agendamentos recebidos:', agendamentos);

    if (!agendamentos || agendamentos.length === 0) {
      this.timeSlots = this.generateEmptyTimeSlots();
      return;
    }

    const sortedAppointments = this.sortAppointmentsByTime(agendamentos);
    this.timeSlots = [];

    for (let hour = 8; hour <= 19; hour++) {
      const hourFormatted = hour.toString().padStart(2, '0');
      const timeSlot = `${hourFormatted}:00`;

      const appointmentsForHour = sortedAppointments.filter(appointment => {
        if (!appointment.horarioAgendamento) {
          return false;
        }

        const timeParts = appointment.horarioAgendamento.split(':');
        if (timeParts.length < 1) {
          return false;
        }

        const appointmentHour = parseInt(timeParts[0], 10);
        return appointmentHour === hour;
      });

      this.timeSlots.push({
        hour: timeSlot,
        appointments: appointmentsForHour
      });
    }
  }

  private generateEmptyTimeSlots(): Array<{hour: string, appointments: AgendamentoDia[]}> {
    const slots = [];
    for (let hour = 8; hour <= 19; hour++) {
      const hourFormatted = hour.toString().padStart(2, '0');
      slots.push({
        hour: `${hourFormatted}:00`,
        appointments: []
      });
    }
    return slots;
  }

  private sortAppointmentsByTime(appointments: AgendamentoDia[]): AgendamentoDia[] {
    return appointments.sort((a, b) => {
      const timeA = this.timeToMinutes(a.horarioAgendamento);
      const timeB = this.timeToMinutes(b.horarioAgendamento);
      return timeA - timeB;
    });
  }

  private timeToMinutes(timeString: string): number {
    if (!timeString) return 0;
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + (minutes || 0);
  }

  // ===== NOVO MÉTODO ADICIONADO =====
  // Método para navegar para detalhes do lead
  navigateToLeadDetails(leadId: number): void {
    if (leadId) {
      this.router.navigate(['/leads', leadId, 'detalhes']);
    } else {
      runtimeLogger.warn('LeadId não encontrado');
      // Opcional: mostrar uma mensagem para o usuário
      alert('Não foi possível encontrar o ID do lead');
    }
  }

  goToToday(): void {
    this.currentDate = new Date();
    this.updateDateInfo();
    this.loadAppointmentsForDay();
  }

  previousDay(): void {
    this.currentDate.setDate(this.currentDate.getDate() - 1);
    this.updateDateInfo();
    this.loadAppointmentsForDay();
  }

  nextDay(): void {
    this.currentDate.setDate(this.currentDate.getDate() + 1);
    this.updateDateInfo();
    this.loadAppointmentsForDay();
  }
}
